import * as React from 'react';
import styled from '@emotion/styled';

const StyledDivResponse = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
`;

const SuggestEditErrorResponse = () => {
  return (
    <StyledDivResponse>
      <h3>Something went wrong. Please try again</h3>
    </StyledDivResponse>
  );
};

export default SuggestEditErrorResponse;
